import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supplier-evaluation-success',
  templateUrl: './supplier-evaluation-success.component.html',
  styleUrls: ['./supplier-evaluation-success.component.scss']
})
export class SupplierEvaluationSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/supplier-evaluation-form/supplier-evaluation-success/supplier-evaluation-success.component.ts